import { render, staticRenderFns } from "./TrainerDetails.vue?vue&type=template&id=6c55d354&"
import script from "./TrainerDetails.vue?vue&type=script&lang=js&"
export * from "./TrainerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrainerDetails.vue"
export default component.exports